<template>
  <div v-if="$_get(student, 'id')">
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          :headline="student ? `${student.name}` : 'Học Sinh'"
          :link="[{ text: 'Học sinh', href: '../students' }, { text: 'Danh sách' }]"
        />
      </div>
    </div>
    <StudentProfile :student="student" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import StudentProfile from './components/StudentProfile'

export default {
  components: {
    StudentProfile,
    Breadcrumbs
  },
  computed: {
    ...mapGetters('student', ['student']),
    formatCode() {
      return this.student.code.substring(this.student.code.length - 5)
    }
  },
  async created() {
    this.setTuitions([])
    await this.fetchStudent(this.$route.params.id)
  },
  methods: {
    ...mapActions('student', ['fetchStudent', 'setTuitions'])
  }
}
</script>
